import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';

export const resolved = async <T,>(promise: () => Promise<T | null>, fallback: T) => {
	try {
		const result = await promise();
		return result ?? fallback;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		if (error.statusCode !== 404) {
			fireErrorAnalytics({
				error,
				meta: {
					id: 'persistentIssueCreateModalViewResource',
					packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
					teamName: 'gryffindor',
				},
				sendToPrivacyUnsafeSplunk: true,
			});
		}
		return fallback;
	}
};
